import "./DefaultModal.scss";
import DefaultModal from "./DefaultModal";

export default DefaultModal